import React, { useState, useRef, useContext } from "react";
import { View, Text, TouchableOpacity, Image, ScrollView } from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import * as Animatable from "react-native-animatable";
import Icon from "react-native-vector-icons/Ionicons";
import InventoryObject from "./InventoryObject";
import { View as DView } from "dripsy";
import FinalAnimation from "./FinalAnimation";
import AppContext from "../context";
// import Share from "react-native-share";
// import { captureRef } from "react-native-view-shot-with-web-support";

export default function GameModals({ g, show, next, skip, cancel }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const cap = useRef();
  const [captureText, setCaptureText] = useState("");
  const [captureTextTop, setCaptureTextTop] = useState("");
  const { tour, resolveURL, dict } = useContext(AppContext);

  const shareFinalScore = () => {
    setCaptureText("https://www.guidigo.com/" + tour.encryptTourID);
    setCaptureTextTop(dict.share_text_1 + tour.name + dict.share_text_2);
    // setTimeout(() => {
    //   captureRef(cap, {
    //     format: "jpg",
    //     quality: 0.8,
    //   }).then(
    //     (url) => {
    //       //console.log('Image saved to', url);
    //       setCaptureText("");
    //       setCaptureTextTop("");
    //       Share.open({
    //         url,
    //         message:
    //           dict.share_text_1 +
    //           tour.name +
    //           dict.share_text_3 +
    //           "https://www.guidigo.com/" +
    //           tour.encryptTourID,
    //         title: "https://www.guidigo.com/" + tour.encryptTourID,
    //       });
    //     },
    //     (error) => console.error("Oops, snapshot failed", error)
    //   );
    // }, 100);
  };

  const topIcon = () => {
    // console.log(g);
    if (g.objectType === "Letter")
      return (
        <View
          style={{
            backgroundColor: "#E25BBE",
            width: 40,
            height: 40,
            marginRight: 8,
            borderRadius: 20,
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          {theme === "dark" ? (
            <Image
              source={require("../assets/letter-dark.png")}
              style={{ width: 20, height: 20 }}
            />
          ) : (
            <Image
              source={require("../assets/letter.png")}
              style={{ width: 20, height: 20 }}
            />
          )}
        </View>
      );

    if (g.objectType === "Puzzle")
      return (
        <View
          style={{
            backgroundColor: "#7B7BBA",
            width: 40,
            height: 40,
            marginRight: 8,
            borderRadius: 20,
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          {theme === "dark" ? (
            <Image
              source={require("../assets/puzzle-dark.png")}
              style={{ width: 26, height: 26 }}
            />
          ) : (
            <Image
              source={require("../assets/puzzle.png")}
              style={{ width: 26, height: 26 }}
            />
          )}
        </View>
      );
    return (
      <View
        style={{
          backgroundColor: "#FDC82A",
          width: 40,
          height: 40,
          marginRight: 8,
          borderRadius: 20,
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        {theme === "dark" ? (
          <Image
            source={require("../assets/inventory.png")}
            style={{ width: 22, height: 20 }}
          />
        ) : (
          <Image
            source={require("../assets/inventory-white.png")}
            style={{ width: 22, height: 20 }}
          />
        )}
      </View>
    );
  };

  return (
    <Animatable.View
      animation={"fadeIn"}
      duration={300}
      style={{
        position: "absolute",
        backgroundColor: colors[theme].bg07,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        elevation: 5,
      }}
    >
      <Animatable.View
        animation={
          show === "correct" ||
          show === "wrong" ||
          show === "skip" ||
          show === "afterPhoto" ||
          show === "final"
            ? "bounceInDown"
            : ""
        }
        style={{
          width: "100%",
          alignItems: "center",
        }}
        ref={cap}
      >
        <DView
          sx={{
            backgroundColor: colors[theme].bg,
            width: ["90%", 350],
            padding: 20,
            borderRadius: 10,
            margin: "auto",
          }}
        >
          {(show === "correct" || show === "afterPhoto") && (
            <View style={{ alignItems: "center" }}>
              <View
                style={{
                  backgroundColor: "#26C97A",
                  width: 40,
                  height: 40,
                  marginRight: 8,
                  borderRadius: 20,
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <Icon
                  name="md-checkmark-sharp"
                  size={30}
                  color={colors[theme].bg}
                />
              </View>
              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                }}
              >
                {dict.challenge_completed}
              </Text>
              {theme === "dark" ? (
                <Image
                  source={require("../assets/conffeti-bg-dark.png")}
                  style={{
                    width: 220,
                    height: 269,
                    position: "absolute",
                    top: 100,
                  }}
                />
              ) : (
                <Image
                  source={require("../assets/conffeti-bg.png")}
                  style={{
                    width: 220,
                    height: 269,
                    position: "absolute",
                    top: 100,
                  }}
                />
              )}
              <Image
                source={require("../assets/conffeti.gif")}
                style={{ width: 250, height: 220, marginBottom: 50 }}
              />
              <View
                style={{
                  position: "absolute",
                  top: 130,
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    textAlign: "center",
                    marginTop: 30,
                    color: colors[theme].text,
                    opacity: 0.7,
                    fontWeight: "bold",
                  }}
                >
                  {dict.you_reward}
                </Text>
                <Text
                  style={{
                    fontSize: 64,
                    textAlign: "center",
                    fontWeight: "bold",
                    color: colors[theme].text,
                  }}
                >
                  {g.score}
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    textAlign: "center",
                    marginBottom: 50,
                    color: colors[theme].text,
                    opacity: 0.7,
                    fontWeight: "bold",
                  }}
                >
                  {dict.points}
                </Text>
              </View>
              <TouchableOpacity
                onPress={() => next()}
                style={{ padding: 10, width: "100%", marginTop: 30 }}
              >
                <Text
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    color: "#26C97A",
                    fontWeight: "bold",
                  }}
                >
                  {dict.collect}
                </Text>
              </TouchableOpacity>
            </View>
          )}
          {show === "wrong" && (
            <View style={{ alignItems: "center" }}>
              <View
                style={{
                  backgroundColor: "#DD4D4D",
                  width: 40,
                  height: 40,
                  borderRadius: 20,
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <Icon
                  name="md-close-sharp"
                  size={30}
                  color={colors[theme].bg}
                  style={{ marginLeft: 2 }}
                />
              </View>
              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                }}
              >
                {dict.wrong_answer}
              </Text>
              {g.challengeType != "FindObject" && (
                <Text
                  style={{
                    color: colors[theme].text,
                    opacity: 0.5,
                    marginTop: 10,
                  }}
                >
                  {g.maxNumberOfAttempts}{" "}
                  {g.maxNumberOfAttempts > 1 ? dict.tries_left : dict.try_left}
                </Text>
              )}
              {theme === "dark" ? (
                <Image
                  source={require("../assets/wrong-dark.png")}
                  style={{
                    width: 222,
                    height: 170,
                    marginVertical: 30,
                    marginLeft: 33,
                  }}
                />
              ) : (
                <Image
                  source={require("../assets/wrong.png")}
                  style={{
                    width: 222,
                    height: 170,
                    marginVertical: 30,
                    marginLeft: 33,
                  }}
                />
              )}
              <TouchableOpacity
                onPress={() => next()}
                style={{ padding: 10, width: "100%" }}
              >
                <Text
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    color: colors[theme].text,
                    fontWeight: "bold",
                  }}
                >
                  {g.maxNumberOfAttempts === 0 ? dict.next : dict.try_again}
                </Text>
              </TouchableOpacity>
            </View>
          )}
          {show === "skip" && (
            <View style={{ alignItems: "center" }}>
              <View
                style={{
                  backgroundColor: "#FDC82A",
                  width: 40,
                  height: 40,
                  marginRight: 8,
                  borderRadius: 20,
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                {theme === "dark" ? (
                  <Image
                    source={require("../assets/skip-arrow-black.png")}
                    style={{ width: 19, height: 14 }}
                  />
                ) : (
                  <Image
                    source={require("../assets/skip-arrow.png")}
                    style={{ width: 19, height: 14 }}
                  />
                )}
              </View>
              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                }}
              >
                {dict.challenge_skipped}
              </Text>
              <Text
                style={{
                  color: colors[theme].text,
                  opacity: 0.5,
                  marginTop: 10,
                }}
              >
                {dict["0_tries_left"]}
              </Text>
              <Image
                source={require("../assets/skip.png")}
                style={{
                  width: 145,
                  height: 107,
                  marginVertical: 30,
                }}
              />
              <TouchableOpacity
                onPress={() => next()}
                style={{ padding: 10, width: "100%" }}
              >
                <Text
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    color: colors[theme].text,
                    fontWeight: "bold",
                  }}
                >
                  {dict.next}
                </Text>
              </TouchableOpacity>
            </View>
          )}
          {show === "inventory" && (
            <View style={{ alignItems: "center" }}>
              {topIcon()}

              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                  marginBottom: 30,
                  fontWeight: "600",
                }}
              >
                {dict.and_you_found}
              </Text>
              <InventoryObject o={g} />
              <TouchableOpacity
                onPress={() => next()}
                style={{
                  marginTop: 10,
                  padding: 10,
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    color: colors[theme].text,
                    fontWeight: "bold",
                  }}
                >
                  {dict.next}
                </Text>
                <Icon
                  name="chevron-forward"
                  size={26}
                  color={colors[theme].text}
                  style={{ marginLeft: 5 }}
                />
              </TouchableOpacity>
            </View>
          )}
          {show === "didYouKnow" && (
            <View style={{ alignItems: "center" }}>
              <View
                style={{
                  backgroundColor: "#23A7F1",
                  width: 40,
                  height: 40,
                  marginRight: 8,
                  borderRadius: 20,
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <Text style={{ fontSize: 28, color: colors[theme].bg }}>?</Text>
              </View>
              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                  marginBottom: 20,
                  fontWeight: "600",
                }}
              >
                {dict.did_you_know}
              </Text>
              <Text
                style={{
                  fontSize: 16,
                  textAlign: "center",
                  color: colors[theme].text,
                  lineHeight: 24,
                }}
              >
                {g.answerComplementMessage}
              </Text>
              <TouchableOpacity
                onPress={() => next()}
                style={{
                  marginTop: 30,
                  padding: 10,
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    color: colors[theme].text,
                    fontWeight: "bold",
                  }}
                >
                  {dict.next}
                </Text>
                <Icon
                  name="chevron-forward"
                  size={26}
                  color={colors[theme].text}
                  style={{ marginLeft: 5 }}
                />
              </TouchableOpacity>
            </View>
          )}
          {show === "skipAsk" && (
            <View style={{ alignItems: "center" }}>
              <Image
                source={require("../assets/exclamination.png")}
                style={{ width: 40, height: 40 }}
              />
              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                  marginBottom: 20,
                  fontWeight: "bold",
                  marginTop: 40,
                }}
              >
                {dict.skip_challenge}
              </Text>
              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                {dict.skip_challenge_confirm}
              </Text>
              <View
                style={{
                  flexDirection: "row",
                }}
              >
                <TouchableOpacity
                  onPress={() => cancel()}
                  style={{ marginTop: 20, marginRight: 40, padding: 10 }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      textAlign: "center",
                      color: colors[theme].text,
                      fontWeight: "bold",
                    }}
                  >
                    {dict.cancel}
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => skip()}
                  style={{ marginTop: 20, marginLeft: 40, padding: 10 }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: colors[theme].text,
                    }}
                  >
                    {dict.skip}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          )}
          {show === "correctAnswerWas" && (
            <View style={{ alignItems: "center" }}>
              <View
                style={{
                  backgroundColor: "#DD4D4D",
                  width: 40,
                  height: 40,
                  borderRadius: 20,
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <Icon
                  name="md-close-sharp"
                  size={30}
                  color={colors[theme].bg}
                  style={{ marginLeft: 2 }}
                />
              </View>
              <Text
                style={{
                  fontSize: 19,
                  textAlign: "center",
                  color: colors[theme].text,
                  marginBottom: 20,
                  fontWeight: "600",
                }}
              >
                {dict.correct_answer_was}
              </Text>
              {g.challengeType === "MCQImage" ? (
                <ScrollView horizontal>
                  <View
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      flexWrap: "nowrap",
                    }}
                  >
                    {g.propositions
                      .filter((i) => i.flag)
                      .map((a) => (
                        <Image
                          source={{
                            uri: resolveURL("game", a.imageReference, 300),
                          }}
                          style={{
                            width: 140,
                            height: 140,
                            borderRadius: 8,
                            marginTop: 10,
                            marginHorizontal: 5,
                          }}
                          resizeMode={"contain"}
                          key={a.propositionID}
                        />
                      ))}
                  </View>
                </ScrollView>
              ) : (
                <Text
                  style={{
                    fontSize: 16,
                    textAlign: "center",
                    color: colors[theme].text,
                  }}
                >
                  {g.goodAnswer}
                </Text>
              )}
              <TouchableOpacity
                onPress={() => next()}
                style={{
                  marginTop: 50,
                  padding: 10,
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    color: colors[theme].text,
                    fontWeight: "bold",
                  }}
                >
                  {dict.next}
                </Text>
                <Icon
                  name="chevron-forward"
                  size={26}
                  color={colors[theme].text}
                  style={{ marginLeft: 5 }}
                />
              </TouchableOpacity>
            </View>
          )}
          {show === "final" && (
            <FinalAnimation
              cancel={cancel}
              share={shareFinalScore}
              captureText={captureText}
              captureTextTop={captureTextTop}
            />
          )}
        </DView>
      </Animatable.View>
    </Animatable.View>
  );
}
